export const GENERAL_FAQ = [
  {
    q: "Who operates Cabil?",
    a: "Cabil is the trading name (DBA) of Cabil Educational Services, a Karachi, Pakistan-based company offering online mentorship, career guidance, and AI-powered learning products, including Cabil Kids for children ages 4-12.",
  },
  {
    q: "What does Cabil offer?",
    a: "Two main products: (1) a mentorship platform connecting students and professionals with expert mentors for career guidance and online/home tutoring, and (2) Cabil Kids, a subscription-based learning app with educational games, an AI study buddy, and parent-controlled features for children.",
  },
  {
    q: "What currency are prices shown in?",
    a: "All prices on Cabil, including mentorship sessions and Cabil Kids subscription plans, are listed and charged in Pakistani Rupees (PKR).",
  },
  {
    q: "What payment methods are accepted?",
    a: "Cabil accepts payments through our payment gateway partner, supporting major debit/credit cards and bank transfers available in Pakistan. Payment is processed securely and is never handled directly by a child's account.",
  },
  {
    q: "Can I get a refund?",
    a: "Yes, in specific cases such as duplicate charges, billing errors, or sessions that didn't take place due to a fault on our side. See our full Refund & Cancellation Policy for details on eligibility and how to request one.",
  },
  {
    q: "How do I cancel my subscription or a booked session?",
    a: "Cabil Kids subscriptions can be cancelled anytime from Settings. Mentorship sessions can be cancelled or rescheduled up to 24 hours before the scheduled time from your dashboard. See our Refund & Cancellation Policy for full details.",
  },
  {
    q: "Is my data safe with Cabil?",
    a: "Yes. We explain exactly what data we collect, how it's stored, and how it's used in our Privacy Policy. We don't sell customer data, and Cabil Kids is built with strict parental controls and no third-party advertising.",
  },
  {
    q: "How can I contact Cabil?",
    a: "Email us at info@cabil.co, call or WhatsApp +92 331 4622245, or use the form on our Contact page. Our offices are in Karachi, Pakistan.",
  },
];
